<div class="ui basic segment">

    <h3>
        <span>Events for {{parent_agency_name}}</span>
    </h3>

    <h5 class="ui warning message" style="width:90%;margin: auto;font-size: 110%">
        <b>NOTE:</b> Events displayed are ONLY for departments using the Sinirji 911 System. If you don't see your
        events listed
        you can <a href="/contact">contact us</a> for more information
    </h5>

    <div *ngIf="!db_read_complete">
        <div class="ui active inverted dimmer">
            <div class="ui large text loader">Loading Event Data ...</div>
        </div>
    </div>

    <div *ngIf="db_read_complete">
        <div class="cards">
            <div class="no-events" *ngIf="events.length === 0">
                No Events To Display
            </div>

            <div *ngIf="events.length > 0">
                <div *ngFor="let event of events" class="ui card">

                    <div class="content">
                        <h5 class="header">
                            {{event.type}} | {{event.agencies}}
                            <button (click)="event.view_map = !event.view_map" class="map ui primary tiny button">
                                <span *ngIf="event.view_map">Close Map</span>
                                <span *ngIf="!event.view_map">View Map</span>
                            </button>
                        </h5>
                    </div>

                    <table class="ui basic stackable table">
                        <thead class="thead">
                            <tr>
                                <th>Street</th>
                                <th>Cross Streets</th>
                                <th>City</th>
                                <th>Status</th>
                                <th>Level</th>
                                <th>Time</th>
                                <th>Responding Units</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{event.street}}</td>
                                <td>{{event.cross_streets}}</td>
                                <td>{{event.city}}</td>
                                <td>{{event.status}}</td>
                                <td>{{event.level}}</td>
                                <td>{{event.time}}</td>
                                <td>{{event.units}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div *ngIf="event.view_map">
                        <app-map [events]="[event]" [params]="{lat : event.lat, lng : event.lng, fit_bounds : true}">
                        </app-map>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/agency/agency.component.html